import { render, staticRenderFns } from "./YogaPlacePhone.vue?vue&type=template&id=5afefcb0&scoped=true&"
import script from "./YogaPlacePhone.vue?vue&type=script&lang=js&"
export * from "./YogaPlacePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afefcb0",
  null
  
)

export default component.exports